import type { ComponentType } from "react";

export interface ICampaignsDashboardWizardProps {
    widgetPreview: any;
}

let campaignsDashboardWizard: ComponentType<ICampaignsDashboardWizardProps> | null = null;

/**
 * The RankTracker wizard step is owned by dm-keywords-campaigns; the dashboard shell only
 * needs to render whatever that module registers, so it stays out of app-shared's imports.
 */
export const setCampaignsDashboardWizard = (component: ComponentType<ICampaignsDashboardWizardProps>): void => {
    campaignsDashboardWizard = component;
};

export const getCampaignsDashboardWizard = (): ComponentType<ICampaignsDashboardWizardProps> | null =>
    campaignsDashboardWizard;
